<template>
  <span class="tag-component"
        :class="[
          `type-${type}`,
          `size-${size}`
        ]"
  >{{ text }}</span>
</template>

<script>
  export default {
    name: 'YmTag',
    props: {
      text: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        validator(val) {
          return [
            'primary',
            'primary-gradient',
            'highlight',
            'highlight-gradient',
          ].includes(val);
        },
        default: 'primary-gradient',
      },
      size: {
        type: String,
        validator(val) {
          return [
            'small',
            'normal',
          ].includes(val);
        },
        default: 'normal',
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @tag-height: @size-medium;
  @tag-small-height: @size-base;

  .tag-component {
    color: @color-white;
    font-size: @font-size-small;
    padding: 0 (@size-extra-small * 1.5);
    height: @tag-height;
    line-height: @tag-height;
    border-top-right-radius: @tag-height / 2;
    border-bottom-right-radius: @tag-height / 2;
    &.type-primary {
      background: @color-primary-aide;
    }
    &.type-primary-gradient {
      background: @gradient-primary;
    }
    &.type-highlight {
      background: @color-highlight;
    }
    &.type-highlight-gradient {
      background: @gradient-highlight-secondary;
    }
    &.size-small {
      font-size: @font-size-extra-extra-small;
      padding: 0 (@size-extra-small * 1.2);
      height: @tag-small-height;
      line-height: @tag-small-height;
      border-top-right-radius: @tag-small-height / 2;
      border-bottom-right-radius: @tag-small-height / 2;
    }
  }
</style>
